import React from 'react';
import SkeletonLoader from '../../../components/ui/SkeletonLoader';

const ViewerSkeleton = () => {
  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar skeleton */}
      <div className="hidden lg:block w-[280px] border-r border-border bg-card p-4">
        <SkeletonLoader variant="title" className="mb-6" />
        <div className="space-y-3">
          {[1, 2, 3, 4, 5]?.map((i) => (
            <SkeletonLoader key={i} variant="default" className="h-10" />
          ))}
        </div>
      </div>
      {/* Main content skeleton */}
      <div className="flex-1 flex flex-col overflow-hidden lg:ml-[280px]">
        <div className="flex-1 flex overflow-hidden">
          {/* Flipbook viewer skeleton */}
          <div className="flex-1 flex items-center justify-center bg-muted/30 p-8">
            <SkeletonLoader className="w-[800px] h-[600px] md:w-[900px] md:h-[675px] lg:w-[1000px] lg:h-[750px]" />
          </div>

          {/* Thumbnail sidebar skeleton */}
          <div className="w-64 border-l border-border bg-card p-4 space-y-3">
            {[1, 2, 3, 4]?.map((i) => (
              <SkeletonLoader key={i} variant="thumbnail" className="h-32" />
            ))}
          </div>
        </div>

        {/* Toolbar skeleton */}
        <div className="border-t border-border bg-card p-4">
          <div className="flex items-center justify-between">
            <SkeletonLoader variant="button" className="w-32" />
            <SkeletonLoader variant="button" className="w-48" />
            <SkeletonLoader variant="button" className="w-32" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewerSkeleton;